import axios from "axios";
import { getToken } from "../utils/authStorage";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5010/api";

/**
 * Receivable Report Service
 * Follow-up style service with dynamic filters for hidden income receivables
 */

// Interfaces
export interface FilterCondition {
  field: string;
  operator: "=" | "!=" | ">" | ">=" | "<" | "<=" | "between";
  value: string | number | boolean | [number, number];
}

export interface ReceivableFilters {
  logic?: "AND" | "OR";
  conditions?: FilterCondition[];
}

export interface ReceivableBooking {
  bookingId: string;
  bookingDate: string;
  customerName: string;
  customerContact: string;
  projectName: string;
  unitRef: string;
  unitType: string;
  wing: string;
  otherWorkExpected: number;
  otherWorkCollected: number;
  terraceWorkExpected: number;
  terraceWorkCollected: number;
  chargesExpected: number;
  chargesCollected: number;
  banakhatExpected: number;
  banakhatCollected: number;
  adaniGasExpected: number;
  adaniGasCollected: number;
  totalExpected: number;
  totalCollected: number;
  totalPending: number;
  pendingPercent: number;
  receivedPercent: number;
  collectionCount: number;
  lastCollectionDate: string | null;
  lastCollectionAmount: number | null;
  daysSinceBooking: number;
  daysSinceLastCollection: number | null;
  status: string;
}

export interface Project {
  id: number;
  name: string;
}

export interface ReceivableReportData {
  bookings: ReceivableBooking[];
  projects: Project[];
}

class ReceivableReportService {
  /**
   * Get receivable report data with optional dynamic filters
   */
  async getReceivableReportData(
    projectId?: string,
    dateFrom?: string,
    dateTo?: string,
    filters?: ReceivableFilters
  ): Promise<ReceivableReportData> {
    const token = getToken();
    const payload: any = {};

    if (projectId) payload.projectId = projectId;
    if (dateFrom) payload.dateFrom = dateFrom;
    if (dateTo) payload.dateTo = dateTo;
    if (filters) payload.filters = filters;

    const response = await axios.post(`${API_URL}/reports/receivable/data`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }
}

export default new ReceivableReportService();
